import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var DealWordmark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "75",
    height: "28",
    viewBox: "0 0 75 28"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M29.234 15.258s.72-3.352 4.286-3.352c3.682 0 4.19 3.352 4.19 3.352h-8.476zm13.826 1.409c0 .6-.047 1.177-.1 1.648a1.258 1.258 0 0 1-1.248 1.118H29.136s.861 3.755 5.24 3.755c1.599 0 3.146-.593 4.092-1.239a1.339 1.339 0 0 1 1.764.226l1.3 1.486c.51.583.427 1.478-.183 1.956C39.995 26.68 37.43 28 34.124 28c-5.793 0-10.143-4.569-10.143-10.21 0-5.884 4.244-10.559 9.855-10.559 6.84 0 9.224 5.674 9.224 9.436zM19.743.004a1.28 1.28 0 0 1 1.278 1.283c-.002 2.879-.004 9.769-.002 11.946 0 .457-.158.896-.45 1.247L9.903 27.333a1.537 1.537 0 0 1-1.409.538C3.557 27.147 0 22.124 0 17.597 0 11.883 4.628 7.234 10.317 7.234c1.347 0 2.905.352 4.508 1.017l.943.405V1.273c0-.701.565-1.27 1.263-1.27h2.712zm-.982 20.289c.619-.746 1.628-.742 2.194.044a4.82 4.82 0 0 1 .896 2.557c.127 2.256-1.395 4.337-3.574 4.897a4.745 4.745 0 0 1-3.195-.287c-.914-.424-1.134-1.407-.49-2.185l4.17-5.026zM69.746 1.209c0-.667.54-1.209 1.204-1.209h2.846C74.461 0 75 .542 75 1.21v25.154c0 .663-.535 1.2-1.195 1.2H70.94c-.66 0-1.195-.537-1.195-1.2V1.209zm-8.87 7.393c0-.682.535-1.091 1.214-1.091h2.706c.68 0 1.23.553 1.23 1.235v17.575a1.24 1.24 0 0 1-1.238 1.243H63.74c-.43 0-.828-.232-1.04-.61l-.88-1.559s-2.246 2.49-5.976 2.49c-5.487 0-10.135-4.27-10.423-9.774-.311-5.946 4.416-10.883 10.269-10.883 2.372 0 4.181.758 5.186 1.374zM8.615 21.77c.463-.463 5.366-6.314 5.366-6.314.592-.805.11-1.583-.148-1.797a5.291 5.291 0 0 0-3.258-1.231c-2.978-.064-5.421 2.35-5.421 5.328 0 1.552.672 3.012 1.821 4.02.467.409 1.177.456 1.64-.006zm47.142 1.072c2.904 0 5.267-2.373 5.267-5.29 0-2.918-2.363-5.29-5.267-5.29-2.904 0-5.267 2.372-5.267 5.29 0 2.917 2.363 5.29 5.267 5.29z"
  }));
});

export default DealWordmark;
//# sourceMappingURL=deal-wordmark.svg.js.map
